import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderSlot as _renderSlot, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "station-form-category-container" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col justify-center bg-warning p-3 rounded"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "O médico ainda está pendente!", -1)
const _hoisted_4 = { class: "flex items-center gap-4 flex-wrap sm:flex-nowrap" }
const _hoisted_5 = {
  key: 1,
  class: "station-form-category-title"
}
const _hoisted_6 = { class: "station-form-category-content" }
const _hoisted_7 = {
  key: 0,
  class: "station-form-category-columns"
}
const _hoisted_8 = { class: "station-form-category-columns" }

import { onMounted, computed, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useDoctorStore } from '@/pinia-store/useDoctorStore'
import { mdiContentCopy } from '@mdi/js'
import { useToast } from 'vue-toastification'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import { ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'prices.form',
  props: [
  'doctor',
  'doctorName',
  'value',
  'company',
  'inCash',
  'modifiedValue',
  'advanceRequested',
  'advancePaid',
  'originalDoctor',
  'urlConviteDoctor',
  'originalValue',
  'updateForm',
  'modifiedValueEnabled',
  'onValidateDoctor',
  'canValidate',
  'isLoadingAuthorization',
  'isDoctorValidatedProp',
  'minimal'
],
  emits: [
  'update:doctor',
  'update:doctorName',
  'update:value',
  'update:inCash',
  'update:advanceRequested',
  'update:advancePaid',
  'update:modifiedValue'
],
  setup(__props, { emit }) {

const props = __props;

const toast = useToast()

const copyConvite = async (e) => {
  e.preventDefault()
  await navigator.clipboard.writeText(props.urlConviteDoctor || '')
  toast.success('Link copiado com sucesso')
}




const isDoctorValidated = ref(true)

const doctorFilter = (itemTitle, queryText, item) => {
  const name = item.raw.title.toLowerCase()
  const crm = item.raw.subtitle.toLowerCase()
  const searchText = queryText.toLowerCase()
  return name.includes(searchText) || crm.includes(searchText)
}

onMounted(() => {
  if (props.doctor) {
    isDoctorValidated.value = true
  }
})

watch(
  () => props.isDoctorValidatedProp,
  (newValue) => {
    isDoctorValidated.value = newValue
  },
  { immediate: true }
)

const disableValidateButton = computed(() => {
  const isSameDoctor = Number(props.doctor) === Number(props.originalDoctor)
  return isDoctorValidated.value || !props.doctor || isSameDoctor
})

const { listDoctorsCompany } = storeToRefs(useDoctorStore())

const listDoctorsComputed = computed(() => {
  //Necessário este computed para adicionar o médico selecionado na lista pois pode ocorrer da listagem não conter o médico selecionado.
  if (listDoctorsCompany.value.filter((item) => item.value === props.doctor).length === 0) {
    return [
      ...listDoctorsCompany.value,
      { value: props.doctor, title: props.doctorName || '', subtitle: '' }
    ]
  }

  return listDoctorsCompany.value
})

const setDoctor = (doctorId: string) => {
  if (doctorId) {
    const selected = listDoctorsCompany.value.find((d) => d.value === doctorId)
    emit('update:doctor', Number(doctorId))
    emit('update:doctorName', selected?.title || '')
    isDoctorValidated.value = false
  } else {
    emit('update:doctor', null)
    emit('update:doctorName', '')
  }
}

const setValue = (value: string) => emit('update:value', Number(value))
const setAdvanceRequested = () => emit('update:advanceRequested', !props.advanceRequested)
const setAdvancePaid = () => emit('update:advancePaid', !props.advancePaid)
const setInCash = () => emit('update:inCash', !props.inCash)
const setModifiedValue = () => emit('update:modifiedValue', !props.modifiedValue)

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.urlConviteDoctor && Number(__props.originalDoctor) === Number(__props.doctor))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("a", {
            href: "",
            onClick: copyConvite,
            class: "text-sm flex justify-center items-center gap-1"
          }, [
            _createVNode(_component_v_icon, { icon: _unref(mdiContentCopy) }, null, 8, ["icon"]),
            _createTextVNode(" Clique para copiar o link do convite ")
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_autocomplete, {
        "onUpdate:modelValue": setDoctor,
        items: listDoctorsComputed.value,
        "model-value": __props.doctor ? String(__props.doctor) : undefined,
        "item-title": "title",
        "item-value": "value",
        "custom-filter": doctorFilter,
        class: "flex-1 min-w-[250px]",
        color: "primary20",
        clearable: "",
        label: "Nome ou CRM do médico",
        theme: "light",
        variant: "outlined",
        density: "comfortable",
        disabled: !__props.company,
        "hide-details": "auto"
      }, {
        item: _withCtx(({ props, item }) => [
          _createVNode(_component_v_list_item, _mergeProps(props, {
            title: item?.raw?.title,
            subtitle: item?.raw?.subtitle
          }), null, 16, ["title", "subtitle"])
        ]),
        _: 1
      }, 8, ["items", "model-value", "disabled"]),
      _createVNode(FilledButton, {
        text: isDoctorValidated.value ? 'Validado' : 'Validar aptidão',
        height: "44px",
        width: "180px",
        loading: props.isLoadingAuthorization,
        onClick: props.onValidateDoctor,
        disabled: disableValidateButton.value
      }, null, 8, ["text", "loading", "onClick", "disabled"])
    ]),
    _renderSlot(_ctx.$slots, "middle-section"),
    (!props.minimal)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Valores"))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      (!props.minimal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (!__props.updateForm || __props.modifiedValue || !__props.originalValue)
              ? (_openBlock(), _createBlock(_component_v_text_field, {
                  key: 0,
                  "onUpdate:modelValue": setValue,
                  "model-value": __props.value,
                  class: "w-full max-w-[290px]",
                  prefix: "R$",
                  type: "number",
                  label: 
            (__props.modifiedValue && __props.modifiedValueEnabled) || !__props.modifiedValueEnabled
              ? 'Valor acordado com o médico'
              : 'Valor original do plantão'
          ,
                  color: "primary20",
                  variant: "outlined",
                  density: "comfortable"
                }, null, 8, ["model-value", "label"]))
              : (_openBlock(), _createBlock(_component_v_text_field, {
                  key: 1,
                  "model-value": __props.originalValue,
                  disabled: "",
                  class: "w-full max-w-[290px]",
                  prefix: "R$",
                  type: "number",
                  label: "Valor original do plantão",
                  color: "primary20",
                  variant: "outlined",
                  density: "comfortable"
                }, null, 8, ["model-value"]))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        (!props.minimal)
          ? (_openBlock(), _createBlock(_component_v_checkbox, {
              key: 0,
              onClick: setInCash,
              "model-value": __props.inCash,
              density: "compact",
              label: "Pagamento à vista",
              color: "primary"
            }, null, 8, ["model-value"]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_checkbox, {
          disabled: true,
          onClick: setAdvanceRequested,
          "model-value": __props.advanceRequested,
          density: "compact",
          color: "primary",
          label: "Antecipação solicitada"
        }, null, 8, ["model-value"]),
        _createVNode(_component_v_checkbox, {
          disabled: true,
          onClick: setAdvancePaid,
          "model-value": __props.advancePaid,
          density: "compact",
          color: "primary",
          label: "Antecipação paga"
        }, null, 8, ["model-value"]),
        ((__props.updateForm || __props.modifiedValueEnabled) && !props.minimal)
          ? (_openBlock(), _createBlock(_component_v_checkbox, {
              key: 1,
              onClick: setModifiedValue,
              "model-value": __props.modifiedValue,
              density: "compact",
              color: "primary",
              label: "Valor Modificado"
            }, null, 8, ["model-value"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})